import type {InstagramReelMusic} from '@Components/social-media/publish-params.types';
import type {InstagramAudioTrack} from '@Components/social-media-wizard/social-media-wizard.types';

export const REEL_MUSIC_SEARCH_DEBOUNCE_MS = 400;

export enum ReelMusicSearchLayout {
  DROPDOWN = 'dropdown',
  BOTTOM_SHEET = 'bottomSheet',
}

export enum ReelMusicSearchState {
  LOADING = 'LOADING',
  LOADED = 'LOADED',
  ERROR = 'ERROR',
}

export const REEL_MUSIC_SEARCH_CONTROL_ID = {
  CLEAR: 'clear',
  SEARCH: 'search',
} as const;

export interface ReelMusicSearchProps {
  accountId: number;
  chosenReelMusic: InstagramReelMusic | null;
  onSelectTrack: (track: InstagramAudioTrack) => void;
  layout: ReelMusicSearchLayout;
}

export interface ReelMusicSearchView {
  tracks: InstagramAudioTrack[];
  searchState: ReelMusicSearchState;
}

export interface ReelMusicQueryResult extends ReelMusicSearchView {
  query: string;
}

export interface ReelMusicSearchResults {
  searchQuery: string;
  hasSearchQuery: boolean;
  tracks: InstagramAudioTrack[];
  searchState: ReelMusicSearchState;
  changeSearchQuery: (searchQuery: string) => void;
  retrySearch: VoidFunction;
}
